import gettext from '@sdk/lang/gettext';
import AttachmentsPreview from '@sdk/attachments/components/AttachmentsPreview/AttachmentsPreview';
import { useToggle } from '@sdk/common/hooks/useToggle';

import { Article } from '@web/newsfeed/types/Article';
import { ArticleHeader } from '@web/newsfeed/Article/ArticleHeader/ArticleHeader';
import { useArticleSearchContext } from '@web/newsfeed/ArticleSearch/ArticleSearchProvider/ArticleSearchProvider';
import { useParsedContent } from '@web/common/hooks/useParsedContent';
import { ArticleFooter } from '@web/newsfeed/Article/ArticleFooter/ArticleFooter';
import { ArticleComments } from '@web/newsfeed/Article/ArticleComments/ArticleComments';
import { useArticleSearchActions } from '@web/newsfeed/ArticleSearch/hooks/useArticleSearchActions';
import { SearchContentPreview } from '@web/components/SearchContentPreview/SearchContentPreview';
import { SEARCH_ITEM_CONTENT_HEIGHT } from '@web/newsfeed/ArticleSearch/ArticleSearchItem/articleSearchItem.consts';
import {
  SearchItemWrapper,
  SeeMoreButtonText,
  SearchArticleWrapper,
  SearchArticleFooter,
} from '@web/newsfeed/ArticleSearch/ArticleSearchItem/articleSearchItem.styles';

import { useArticleSearchItem } from './articleSearchItem.hooks';

type Props = {
  article: Article;
};

export const ArticleSearchItem = ({ article }: Props) => {
  const { searchQuery } = useArticleSearchContext();
  const parsedContent = useParsedContent(article.content, searchQuery);

  const { openArticle, isPreview, onSeeMore } = useArticleSearchItem(article);
  const { isOn: areCommentsVisible, toggle: toggleComments } = useToggle();
  const { toggleLike } = useArticleSearchActions();

  return (
    <SearchItemWrapper>
      <SearchArticleWrapper onClick={openArticle}>
        <ArticleHeader article={article}></ArticleHeader>

        <SearchContentPreview
          isPreview={isPreview}
          parsedContent={parsedContent}
          previewHeight={SEARCH_ITEM_CONTENT_HEIGHT}
        />
      </SearchArticleWrapper>

      <SearchArticleFooter>
        {!!article.attachments?.length && !isPreview && (
          <AttachmentsPreview attachments={article.attachments} />
        )}

        {isPreview ? (
          <span onClick={onSeeMore}>
            <SeeMoreButtonText>{gettext('See more')}</SeeMoreButtonText>
          </span>
        ) : (
          <ArticleFooter
            article={article}
            onLikeClick={() => toggleLike(article)}
            toggleComments={toggleComments}
          />
        )}
      </SearchArticleFooter>

      {areCommentsVisible && <ArticleComments article={article} />}
    </SearchItemWrapper>
  );
};
